import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getProvince(params) {
	return client.get("general/province", {
		params: params,
	});
}

function getCity(params) {
	return client.get("general/city", {
		params: params,
	});
}

function getSubdistrict(params) {
	return client.get("general/subdistrict", {
		params: params,
	});
}

function getCourierRajaongkir(params) {
	return client.get("general/courier", {
		params: params,
	});
}

function getCostRajaongkir(params) {
	return client.post("general/cost", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getBank(params) {
	return client.get("general/bank", {
		params: params,
	});
}

function getUplineData(params) {
	return client.get("general/checkupline", {
		params: params,
	});
}

function getBankCompany(params) {
	return client.get("general/bank_company", {
		params: params,
	});
}

function getMemberByCode(params) {
	return client.get("general/checkmember", {
		params: params,
	});
}

function getCheckUpline(params) {
	return client.get("general/checkupline", {
		params: params,
	});
}

function getUplineOptions(params) {
	return client.get("member/network/upline_option", {
		params: params,
	});
}

function getCloneList(params) {
	return client.get("member/network/clone", {
		params: params,
	});
}

function getStockistQuota(params) {
	return client.get("member/serial/quota", {
		params: params,
	});
}

export default {
	getProvince,
	getCity,
	getSubdistrict,
	getCourierRajaongkir,
	getCostRajaongkir,
	getBank,
	getUplineData,
	getBankCompany,
	getMemberByCode,
	getCheckUpline,
	getUplineOptions,
	getCloneList,
	getStockistQuota,
};